<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Formateurs" />
            <FormaTeurs />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import FormaTeurs from '../Formateurs/FormaTeurs.vue'


export default {
    name: 'FormateurPage',
    components: {
        NavBar,
        PageTitle,
        FormaTeurs,
        FooterComp,
    }
}
</script>